<template>
  <div class="page-container">
    <h1 class="page-title">{{ t("pages.products.tape.title") }}</h1>

    <!-- 引言部分 -->
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          {{ t("pages.products.tape.introduction.title") }}
        </h2>
      </div>
      <div
        class="text-block"
        v-html="renderContent(t('pages.products.tape.introduction.content'))"
      ></div>
      <div class="content-section">
      <div style="text-align: center;">
        <img src="/images/products/带材图.jpg" />
     
      </div>
    </div>
    </div>

    <div class="decorative-divider"></div>

    <!-- 应用案例部分 -->
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          {{ t("pages.products.tape.introduction.cases[0].title") }}
        </h2>
      </div>
      <div class="model-container">
        <TapeLayerThreeD v-if="is3D" />
      </div>
    </div>
    <div class="decorative-divider"></div>
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          {{ t("pages.products.tape.introduction.cases[1].title") }}
        </h2>
      </div>
    </div>
    <div class="content-section">
      <div class="spec-wrapper">
        <table v-if="isEnglish" class="spec-table">
          <tbody>
            <tr class="app-header-row">
              <td rowspan="20" class="app-domain-cell" style="width: 100px;">APPLICATIONS</td>
              <td class="app-subtitle-cell">Electrical</td>
              <td class="app-subheader-cell">Width</td>
              <td class="app-subheader-cell">Grades</td>
              <td class="app-subheader-cell">Ic(77K, s.f.)</td>
            </tr>
            <tr>
              <td rowspan="9" class="app-direction-cell">
                <img
                  src="/images/products/强电应用.png"
                  alt="Utility"
                  class="inline-image"
                />
                <span>Utility</span>
              </td>
              <td rowspan="3">3mm</td>
              <td>S</td>
              <td>85-120A</td>
            </tr>
            <tr>
              <td>S+</td>
              <td>120-145A</td>
            </tr>
            <tr>
              <td>SUP</td>
              <td>145-165A</td>
            </tr>
            <tr>
              <td rowspan="3">4mm</td>
              <td>S</td>
              <td>110-160A</td>
            </tr>
            <tr>
              <td>S+</td>
              <td>160-200A</td>
            </tr>
            <tr>
              <td>SUP</td>
              <td>200-250A</td>
            </tr>
            <tr>
              <td rowspan="3">12mm</td>
              <td>S</td>
              <td>360-500A</td>
            </tr>
            <tr>
              <td>S+</td>
              <td>500-600A</td>
            </tr>
            <tr>
              <td>SUP</td>
              <td>600-800A</td>
            </tr>
            <tr class="app-header-row">
              <td class="app-subtitle-cell">Electromagnetic</td>
              <td class="app-subheader-cell">Width</td>
              <td class="app-subheader-cell">Grades</td>
              <td class="app-subheader-cell">Ic(4.2K, 10T)</td>
            </tr>
            <tr>
              <td rowspan="9" class="app-direction-cell">
                <img
                  src="/images/products/高场应用.png"
                  alt="Superconducting magnet"
                  class="inline-image"
                />
                <span>Superconducting magnet</span>
              </td>
              <td rowspan="3">3mm</td>
              <td>S</td>
              <td>260-340A</td>
            </tr>
            <tr>
              <td>S+</td>
              <td>340-490A</td>
            </tr>
            <tr>
              <td>SUP</td>
              <td>490-600A</td>
            </tr>
            <tr>
              <td rowspan="3">4mm</td>
              <td>S</td>
              <td>350-450A</td>
            </tr>
            <tr>
              <td>S+</td>
              <td>450-650A</td>
            </tr>
            <tr>
              <td>SUP</td>
              <td>650-800A</td>
            </tr>
            <tr>
              <td rowspan="3">12mm</td>
              <td>S</td>
              <td>1050-1350A</td>
            </tr>
            <tr>
              <td>S+</td>
              <td>1350-1950A</td>
            </tr>
            <tr>
              <td>SUP</td>
              <td>1950-2400A</td>
            </tr>

            <tr class="section-row">
              <td rowspan="3">CUSTOMIZABLE<br>SPECIFICATIONS</td>
              <td>Substrate</td>
              <td colspan="3">50 μm Hastelloy™ (or 30 μm)</td>
            </tr>
            <tr>
              <td>
                Single piece length<br>
                <span style="font-size:0.85em; font-weight:normal">(without Ic dropout)</span>
              </td>
              <td colspan="3">100m~1000m</td>
            </tr>
            <tr>
              <td class="post-title">Post-processing</td>
              <td colspan="3" class="post-cell">
                <table class="post-subtable">
                  <thead>
                    <tr>
                      <th class="diagonal-cell"></th>
                      <th>Thickness options</th>
                      <th>Total thickness</th>
                      <th>Total width</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowspan="3">Copper plating</td>
                      <td>5 μm*2</td>
                      <td>65 μm</td>
                      <td rowspan="3">3mm, 4mm, 12mm</td>
                    </tr>
                    <tr>
                      <td>10 μm*2</td>
                      <td>75 μm</td>
                    </tr>
                    <tr>
                      <td>20 μm*2</td>
                      <td>95 μm</td>
                    </tr>
                    <tr>
                      <td rowspan="2">Copper lamination</td>
                      <td>75 μm*2</td>
                      <td>230 μm</td>
                      <td rowspan="2">4.8mm, 6mm, 12mm</td>
                    </tr>
                    <tr>
                      <td>150 μm*2</td>
                      <td>380 μm</td>
                    </tr>
                    <tr>
                      <td>SS316 lamination</td>
                      <td>80 μm*2</td>
                      <td>240 μm</td>
                      <td>12mm</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr class="section-row">
              <td>COMMON<br>PROPERTIES</td>
              <td colspan="4" class="post-cell">
                <table class="perf-subtable">
                  <thead>
                    <tr>
                      <th class="diagonal-cell"></th>
                      <th>Copper plating</th>
                      <th>Copper lamination</th>
                      <th>SS316 lamination</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Joint resistance</td>
                      <td colspan="3">20-50 nΩ·cm²</td>
                    </tr>
                    <tr>
                      <td>Tensile strength (77K/MPa)</td>
                      <td>600-700 MPa</td>
                      <td>300-400 MPa</td>
                      <td>&gt;700 MPa</td>
                    </tr>
                    <tr>
                      <td>Min. Bending diameter (mm)</td>
                      <td colspan="2">10</td>
                      <td>15</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <table v-else class="spec-table">
          <!-- <thead>
            <tr>
              <th>应用领域</th>
              <th>应用方向</th>
              <th>超导带宽度</th>
              <th>等级</th>
              <th>Ic</th>
            </tr>
          </thead> -->
          <tbody>
            <tr class="app-header-row">
              <td rowspan="20" class="app-domain-cell">应用领域</td>
              <td class="app-subtitle-cell">强电应用</td>
              <td class="app-subheader-cell">超导带宽度</td>
              <td class="app-subheader-cell">等级</td>
              <td class="app-subheader-cell">Ic(77K, s.f.)</td>
            </tr>
            <tr>
              <td rowspan="9" class="app-direction-cell">
                <img
                  src="/images/products/强电应用.png"
                  alt="强电应用"
                  class="inline-image"
                />
                <span>超导电力</span>
              </td>
              <td rowspan="3">3mm</td>
              <td>常规</td>
              <td>85-120A</td>
            </tr>
            <tr>
              <td>高性能</td>
              <td>120-145A</td>
            </tr>
            <tr>
              <td>超高性能</td>
              <td>145-165A</td>
            </tr>
            <tr>
              <td rowspan="3">4mm</td>
              <td>常规</td>
              <td>110-160A</td>
            </tr>
            <tr>
              <td>高性能</td>
              <td>160-200A</td>
            </tr>
            <tr>
              <td>超高性能</td>
              <td>200-250A</td>
            </tr>
            <tr>
              <td rowspan="3">12mm</td>
              <td>常规</td>
              <td>360-500A</td>
            </tr>
            <tr>
              <td>高性能</td>
              <td>500-600A</td>
            </tr>
            <tr>
              <td>超高性能</td>
              <td>600-800A</td>
            </tr>
            <tr class="app-header-row">
              <td class="app-subtitle-cell">高场应用</td>
              <td class="app-subheader-cell">超导带宽度</td>
              <td class="app-subheader-cell">等级</td>
              <td class="app-subheader-cell">Ic(4.2K, 10T)</td>
            </tr>
            <tr>
              <td rowspan="9" class="app-direction-cell">
                <img
                  src="/images/products/高场应用.png"
                  alt="高场应用"
                  class="inline-image"
                />
                <span>超导磁体</span>
              </td>
              <td rowspan="3">3mm</td>
              <td>常规</td>
              <td>260-340A</td>
            </tr>
            <tr>
              <td>高性能</td>
              <td>340-490A</td>
            </tr>
            <tr>
              <td>超高性能</td>
              <td>490-600A</td>
            </tr>
            <tr>
              <td rowspan="3">4mm</td>
              <td>常规</td>
              <td>350-450A</td>
            </tr>
            <tr>
              <td>高性能</td>
              <td>450-650A</td>
            </tr>
            <tr>
              <td>超高性能</td>
              <td>650-800A</td>
            </tr>
            <tr>
              <td rowspan="3">12mm</td>
              <td>常规</td>
              <td>1050-1350A</td>
            </tr>
            <tr>
              <td>高性能</td>
              <td>1350-1950A</td>
            </tr>
            <tr>
              <td>超高性能</td>
              <td>1950-2400A</td>
            </tr>

            <tr class="section-row">
              <td rowspan="4">可选配参数</td>
              <td>基带厚度/材料</td>
              <td colspan="3">30 μm 哈氏合金</td>
            </tr>
            <tr>
              <td>基带厚度/材料</td>
              <td colspan="3">50 μm 哈氏合金</td>
            </tr>
            <tr>
              <td>单根长度</td>
              <td colspan="3">100m~1000m</td>
            </tr>
            <tr>
              <td class="post-title">后处理</td>
              <td colspan="3" class="post-cell">
                <table class="post-subtable">
                  <thead>
                    <tr>
                      <th class="diagonal-cell"></th>
                      <th>镀铜可选厚度</th>
                      <th>带材总厚度</th>
                      <th>带材总宽度</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowspan="3">镀铜</td>
                      <td>5 μm*2</td>
                      <td>65 μm</td>
                      <td rowspan="3">3mm、4mm、12mm</td>
                    </tr>
                    <tr>
                      <td>10 μm*2</td>
                      <td>75 μm</td>
                    </tr>
                    <tr>
                      <td>20 μm*2</td>
                      <td>95 μm</td>
                    </tr>
                    <tr>
                      <td rowspan="2">紫铜封装</td>
                      <td>75 μm*2</td>
                      <td>230 μm</td>
                      <td rowspan="2">4.8mm、6mm、12mm</td>
                    </tr>
                    <tr>
                      <td>150 μm*2</td>
                      <td>380 μm</td>
                    </tr>
                    <tr>
                      <td>不锈钢封装</td>
                      <td>80 μm*2</td>
                      <td>240 μm</td>
                      <td>12mm</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr class="section-row">
              <td>基本性能</td>
              <td colspan="4" class="post-cell">
                <table class="perf-subtable">
                  <thead>
                    <tr>
                      <th class="diagonal-cell"></th>
                      <th>镀铜</th>
                      <th>紫铜封装</th>
                      <th>不锈钢封装</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>接头电阻率</td>
                      <td colspan="3">20-50 nΩ·cm²</td>
                    </tr>
                    <tr>
                      <td>临界拉应力强度（77K/MPa）</td>
                      <td>600-700 MPa</td>
                      <td>300-400 MPa</td>
                      <td>&gt;700 MPa</td>
                    </tr>
                    <tr>
                      <td>最小转弯直径（mm）</td>
                      <td colspan="2">10</td>
                      <td>15</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="decorative-divider"></div>

    <!-- 产品资质部分 -->
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          {{ isEnglish ? 'Certifications' : '产品资质' }}
        </h2>
      </div>
      <div style="text-align: center; margin-top: 20px;">
        <img src="/images/products/ISO9001.png" style="max-width: 100%; box-shadow: 0 0 10px rgba(0,0,0,0.05);" />
      </div>
    </div>
    <div class="decorative-divider"></div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useLangStore } from "@/pinia/stores/lang";
import TapeLayerThreeD from "@/components/Products/TapeLayerThreeD.vue";
// import TapeLayerCanvas from '@/components/Products/TapeLayerCanvas.vue';

const { t } = useI18n();
const langStore = useLangStore();
const is3D = ref(true);

// 判断当前是否为英文
const isEnglish = computed(() => !langStore.currentLang.startsWith('zh'));

// 动态获取产品规格图片路径
const productSpecImage = computed(() => 
  isEnglish.value ? '/images/products/产品规格英文.png' : '/images/products/产品规格.png'
);

const handleModeChange = (value: boolean) => {
  console.log(`切换到${value ? "3D" : "2D"}模式`);
};
// 渲染带有换行的内容
const renderContent = (content: string) => {
  if (!content) return "";
  return content
    .split("\n\n")
    .map((paragraph) => `<p>${paragraph}</p>`)
    .join("");
};
</script>

<style scoped>
@import "@/assets/styles/content-blocks.scss";

.model-controls {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.model-container {
  height: 350px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 40px;
}

.detail-section {
  margin-top: 40px;
}

.detail-section h2 {
  color: var(--primary-color);
  margin-top: 30px;
  margin-bottom: 15px;
  font-size: 1.8rem;
}

.detail-section p {
  line-height: 1.6;
  margin-bottom: 20px;
}

.detail-section ul {
  margin-bottom: 30px;
}

.detail-section li {
  margin-bottom: 10px;
}

.page-container {
  max-width: 1200px;
  margin: 0 auto;
}

@media screen and (max-width: 768px) {
  .page-container {
    padding: 30px 15px;
  }
}
.page-container {
  overflow: auto;
}

.spec-wrapper {
  text-align: center;
}

.spec-image {
  max-width: 100%;
}

.spec-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-size: 0.9em;
  text-align: center;
  /* border: 1px solid #000; */
  box-shadow: none;
}

.spec-table th, .spec-table td {
  border: 0.8px solid #000;
  padding: 6px 4px;
  vertical-align: middle;
  min-width: 54px;
  line-height: 1.2;
}

.spec-table thead th {
  font-weight: bold;
  padding: 6px 4px;
}

.spec-table .section-row td:first-child {

  font-weight: bold;
}

.spec-table .inline-image {
  display: block;
  max-width: 90px;
  margin: 4px auto;
  vertical-align: middle;
}

.spec-table .app-header-row td {
  font-weight: 700;
}

.spec-table .app-domain-cell {
  width: 70px;
  font-weight: 700;
}

.spec-table .app-subtitle-cell {
  width: 92px;
  font-weight: 700;
}

.spec-table .app-subheader-cell {
  font-weight: 700;
}

.spec-table .app-direction-cell span {
  display: block;
}

.spec-table .post-title {
  font-weight: 600;
}

.spec-table .post-cell {
  padding: 0;
}

.post-subtable {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 0.95em;
}

.post-subtable th,
.post-subtable td {
  border: 0.8px solid #000;
  padding: 6px 4px;
  text-align: center;
  vertical-align: middle;
  line-height: 1.3;
}

.post-subtable tr:first-child > * {
  /* border-top: 0; */
}

.post-subtable tr:last-child > * {
  border-bottom: 0;
}

.post-subtable tr > *:first-child {
  border-left: 0;
}

.post-subtable tr > *:last-child {
  border-right: 0;
}

.post-subtable thead th {

  font-weight: 600;
}

.post-subtable .diagonal-cell {
  position: relative;
  padding: 0;
  min-height: 28px;
}

.post-subtable .diagonal-cell::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top right,
    transparent calc(50% - 0.5px),
    #000 50%,
    transparent calc(50% + 0.5px)
  );
  pointer-events: none;
}

.perf-subtable .diagonal-cell {
  position: relative;
  padding: 0;
  min-height: 28px;
}

.perf-subtable .diagonal-cell::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top right,
    transparent calc(50% - 0.5px),
    #000 50%,
    transparent calc(50% + 0.5px)
  );
  pointer-events: none;
}

.perf-subtable {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 0.95em;
}

.perf-subtable th,
.perf-subtable td {
  border: 0.8px solid #000;
  padding: 6px 4px;
  text-align: center;
  vertical-align: middle;
  line-height: 1.3;
}

.perf-subtable tr:first-child > * {
  /* border-top: 0; */
}

.perf-subtable tr:last-child > * {
  border-bottom: 0;
}

.perf-subtable tr > *:first-child {
  border-left: 0;
}

.perf-subtable tr > *:last-child {
  border-right: 0;
}

.perf-subtable thead th {
  font-weight: 600;
}
</style> 
